export const pageUrlGenerator = (page) =>
  `${window.location.protocol}//${window.location.host}${page}`;

export const gameTypes = {
  new: "new",
  popular: "popular",
  lastPlayed: "lastPlayed",
  favourites: "favourites",
};

export const casinoTabs = {
  popular: {
    OneDayTeenPattiPR: {
      href: "/casino/ezg-one-day-teen-patti",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/onedayteenpatti.jpg",
      alt: "one day teen patti",
      name: "One Day Teen Patti",
    },
    AviatorPR: {
      href: "/casino/spribe/aviator",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/Aviator.jpg",
      alt: "aviator",
      name: "Aviator",
    },
    AndarBaharLivePR: {
      href: "/casino/ezugi/AndarBaharLive",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/AndarBahar.jpg",
      alt: "andar bahar live",
      name: "Andar Bahar Lve",
    },
    Cards32PR: {
      href: "/casino/ezugi/thirtytwoCards",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/32Cards.jpg",
      alt: "32 cards",
      name: "32 Cards",
    },
    CrazyTimePR: {
      href: "/casino/evolution/crazytime",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/CrazyTime.jpg",
      alt: "crazy time",
      name: "Crazy Time",
    },
    DoubleBallRoulettePR: {
      href: "/casino/evolution/DoubleBallRoulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/DOubleballROulette.jpg",
      alt: "double ball roulette",
      name: "Double Ball Roulette",
    },
    DragonTiger1PR: {
      href: "/casino/evolution/DragonTiger1",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/dragontiger.jpg",
      alt: "dragon tiger 1",
      name: "Dragon Tiger 1",
    },
    ItalianRoulettePR: {
      href: "/casino/ezugi/ItalianRoulette",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/ItalianRoulette.jpg",
      alt: "italian roulette",
      name: "Italian Roulette",
    },
    Lucky7PR: {
      href: "/casino/ezugi/sevenLucky",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/popular/new/Lucky7-2.jpg",
      alt: "seven lucky",
      name: "Seven Lucky",
    },
  },
  ezugi: {
    UltimateRouletteEZ: {
      href: "/casino/ezg-ultimate-roulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Speed-Roulette1.png",
      alt: "ultimate roulette",
      name: "Ultimate Roulette",
    },
    DiamondRouletteEZ: {
      href: "/casino/ezugi/DiamondRoulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Diamond-roulette1.png",
      alt: "diamond roulette",
      name: "Diamond Roulette",
    },
    NamasteRouletteEZ: {
      href: "/casino/ezugi/NamasteRoulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Namaste-roulette1.png",
      alt: "namaste roulette",
      name: "Namaste Roulette",
    },
    AutoRouletteEZ: {
      href: "/casino/ezugi/AutoRoulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Auto-roulette.png",
      alt: "auto roulette",
      name: "Auto Roulette",
    },
    SpeedAutoRouletteEZ: {
      href: "/casino/ezugi/SpeedAutoRoulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Speed-auto-roulette.png",
      alt: "speed auto roulette",
      name: "Speed Auto Roulette",
    },
    OracleRoulette2EZ: {
      href: "/casino/ezugi/OracleRoulette2",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Oracle-360-roulette.png",
      alt: "oracle roulette 2",
      name: "Oracle Roulette 2",
    },
    ItalianRouletteEZ: {
      href: "/casino/ezugi/ItalianRoulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Italian-roulette1.png",
      alt: "italian roulette",
      name: "Italian Roulette",
    },
    SpanishRouletteEZ: {
      href: "/casino/ezugi/SpanishRoulette",
      code: "",
      casino: "ezugi",
      provider: "Ezugi",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/ezugi/Spanish-roulette.png",
      alt: "spanish roulette",
      name: "Spanish Roulette",
    },
  },
  evolution: {
    InstantRouletteEvo: {
      href: "/casino/ezg-ezgevo-instant-roulette",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/Instantroulette.png",
      alt: "instant roulette",
      name: "Instant Roulette",
    },
    DragonTigerEvo: {
      href: "/casino/ezgevo-dragon-tiger-evo",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/DragonTiger.png",
      alt: "dragon tiger evo",
      name: "Dragon Tiger Evo",
    },
    BaccaratAEvo: {
      href: "/casino/ezgevo-baccarat-a",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/Baccart.png",
      alt: "baccarat a",
      name: "Baccarat A",
    },
    BlackjackAEvo: {
      href: "/casino/ezgevo-blackjack-a",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/Blackjack.png",
      alt: "blackjack a",
      name: "Blackjack A",
    },
    CrazyTimeEvo: {
      href: "/casino/ezgevo-crazy-time",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/CrazyTime.png",
      alt: "crazy time",
      name: "Crazy Time",
    },
    MegaballEvo: {
      href: "/casino/evolution/Megaball",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/Megaball.png",
      alt: "megaball",
      name: "Megaball",
    },
    SuperSicBoEvo: {
      href: "/casino/ezgevo-super-sic-bo",
      code: "",
      casino: "evolution",
      provider: "Evolution",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/evolution/Supersicbo.png",
      alt: "super sic bo",
      name: "Super Sic Bo",
    },
  },
  spribe: {
    mines: {
      href: "/casino/spribe/mines",
      code: "mines",
      casino: "spribe",
      provider: "mines",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/mines.png",
      alt: "mines",
      name: "Mines",
    },
    goal: {
      href: "/casino/spribe/goal",
      code: "goal",
      casino: "spribe",
      provider: "goal",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/goal.png",
      alt: "goal",
      name: "Goal",
    },
    dice: {
      href: "/casino/spribe/dice",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/dice.png",
      alt: "dice",
      name: "Dice",
    },
    aviator: {
      href: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      provider: "aviator",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/aviator.png",
      alt: "aviator",
      name: "Aviator",
    },
    plinko: {
      href: "/casino/spribe/plinko",
      code: "plinko",
      casino: "spribe",
      provider: "plinko",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/plinko.png",
      alt: "plinko",
      name: "Plinko",
    },
    miniroulette: {
      href: "/casino/spribe/miniroulette",
      code: "miniroulette",
      casino: "spribe",
      provider: "miniroulette",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/mini-roulette.png",
      alt: "mini roulette",
      name: "Mini Roulette",
    },
    hilo: {
      href: "/casino/spribe/hilo",
      code: "hilo",
      casino: "spribe",
      provider: "hilo",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/spribe/hilo.png",
      alt: "hilo",
      name: "Hilo",
    },
  },
  aura: {
    BaccaratAura: {
      href: "/casino/aura-baccarat",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/aura/Baccarat.png",
      alt: "baccarat",
      name: "Baccarat",
    },
    DreamCatcherAura: {
      href: "/casino/aura-dream-catcher",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/aura/Dreamcatcher.png",
      alt: "dream catcher",
      name: "Dream Catcher",
    },
    HiLowAura: {
      href: "/casino/aura-hi-low",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/aura/Highlow.png",
      alt: "hi low",
      name: "Hi Low",
    },
    MatkaAura: {
      href: "/casino/aura-matka",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/aura/Matka.png",
      alt: "matka",
      name: "Matka",
    },
    TeenpattiOpenAura: {
      href: "/casino/aura-teenpatti-open",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/aura/OpenTeenpatti.png",
      alt: "teenpatti open",
      name: "Teenpatti Open",
    },
    Race2020Aura: {
      href: "/casino/aura-race-20-20",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/aura/Race2020.png",
      alt: "race 20 20",
      name: "Race 20 20",
    },
    TrioAura: {
      href: "/casino/aura-trio",
      code: "",
      casino: "Aura Gaming",
      provider: "Aura",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/casino/aura/Trio.png",
      alt: "trio",
      name: "Trio",
    },
  },
  sports: {
    InplayCricket: {
      href: "/spmsports/cricket",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/In-play.png",
      alt: "inplay",
      name: "Inplay",
    },
    Cricket: {
      href: "/spmsports/cricket",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/cricket.png",
      alt: "cricket",
      name: "Cricket",
    },
    Soccer: {
      href: "/spmsports/soccer",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/Soccer.png",
      alt: "soccer",
      name: "Soccer",
    },
    Tennis: {
      href: "/spmsports/tennis",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/Tennis.png",
      alt: "tennis",
      name: "Tennis",
    },
    InplayCricket2: {
      href: "/spmsports/cricket",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/In-play.png",
      alt: "inplay",
      name: "Inplay",
    },
    Cricket2: {
      href: "/spmsports/cricket",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/cricket.png",
      alt: "cricket",
      name: "Cricket",
    },
    Soccer2: {
      href: "/spmsports/soccer",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/Soccer.png",
      alt: "soccer",
      name: "Soccer",
    },
    Tennis2: {
      href: "/spmsports/tennis",
      code: "",
      casino: "",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/sports/Tennis.png",
      alt: "tennis",
      name: "Tennis",
    },
  },
  providers: {
    ezugi: {
      href: "/casino/ezugi",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/Ezugi.jpg",
      name: "Ezugi",
      quotes:
        "Experience the excitement at Ezugi Casino, where every game is live and thrilling. Join us to enjoy real-time action and endless opportunities for big wins!",
    },
    evolution: {
      href: "/casino/evolution",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/Evolution.jpg",
      name: "Evolution",
      quotes:
        "Join Evolution Casino for an unmatched gaming experience where innovation meets excitement. Every game is a new opportunity, and every win evolves your adventure!",
    },
    vivo: {
      href: "/casino/vivo",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/vivo.jpg",
      name: "Vivo",
      quotes:
        "Experience the ultimate thrill at Vivo Gaming Casino, where cutting-edge technology meets unparalleled excitement. Play now and turn every game into a winning adventure!",
    },
    qtech: {
      href: "/casino/qtech",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/Qtech.jpg",
      name: "Qtech",
      quotes:
        "Discover the future of gaming at QTech Casino, where innovation and excitement meet. Dive into a world of thrilling games and endless opportunities for big wins!",
    },
    supernowa: {
      href: "/casino/supernowa",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/Supernowa.jpg",
      name: "Supernowa",
      quotes:
        "Unleash your winning potential at Supernowa Casino, where every game shines bright with excitement and every spin brings you closer to extraordinary rewards!",
    },
    xpg: {
      href: "/casino/xpg",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/XPG.jpg",
      name: "XPG",
      quotes:
        "Step into the world of XPG Casino, where cutting-edge gaming meets unmatched excitement. Every game is a new adventure, and every win brings you closer to greatness!",
    },
    worldcasino: {
      href: "/casino/worldcasino",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/WorldCasino.jpg",
      name: "World Casino",
      quotes:
        "Discover endless excitement at World Casino, where every game is a journey to big wins and unforgettable moments. Join us and make your mark on the world of gaming!",
    },
    // aesexy: {
    //   href: "/casino/aesexy",
    //   code: "",
    //   casino: "ezugi",
    //   provider: "",
    //   homeUrl: pageUrlGenerator("/home"),
    //   imgUrl: "./images/providers/aesexy.jpg",
    //   name: "AE Sexy",
    //   quotes:
    //     "Experience the thrill and elegance of AE Sexy, where every game is a captivating adventure, and every win adds a touch of allure. Join us for unforgettable moments!",
    // },
    powergames: {
      href: "/casino/powergames",
      code: "",
      casino: "ezugi",
      provider: "",
      homeUrl: pageUrlGenerator("/home"),
      imgUrl: "./images/providers/powergames.jpg",
      name: "Power Games",
      quotes:
        "Unleash your potential and experience the thrill of winning at Power Games Casino, where every game is a new adventure and every spin brings you closer to your next big win!",
    },
  },
};

export const categorizedCasinoData = {
  roulette: {
    AutoRouletteEzg: {
      href: "/casino/ezg-auto-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/AutoRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Auto Roulette",
      gameType: gameTypes.popular,
    },
    CasinoMarinaRoulette1Ezg: {
      href: "/casino/ezg-casino-marina-roulette-1",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/CasinoMarinaRoulette1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Casino Marina Roulette 1",
      gameType: gameTypes.new,
    },
    CasinoMarinaRoulette2Ezg: {
      href: "/casino/ezg-casino-marina-roulette-2",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/CasinoMarinaRoulette2.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Casino Marina Roulette 2",
      gameType: gameTypes.new,
    },
    CricketAutoRouletteEzg: {
      href: "/casino/ezg-cricket-auto-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/CricketAutoRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Cricket Auto Roulette",
      gameType: gameTypes.popular,
    },
    DiamondRouletteEzg: {
      href: "/casino/ezg-diamond-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/DiamondRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Diamond Roulette",
      gameType: gameTypes.popular,
    },
    FirstPersonAmericanRouletteEzg: {
      href: "/casino/ezg-first-person-american-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/FirstPersonAmericanRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "First Person American Roulette",
      gameType: gameTypes.new,
    },
    FootballAutoRouletteEzg: {
      href: "/casino/ezg-football-auto-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/FootballAutoRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Football Auto Roulette",
      gameType: gameTypes.new,
    },
    ItalianRouletteEzg: {
      href: "/casino/ezg-italian-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/ItalianRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Italian Roulette",
      gameType: gameTypes.popular,
    },
    NamasteRouletteEzg: {
      href: "/casino/ezg-namaste-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/NamasteRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Namaste Roulette",
      gameType: gameTypes.popular,
    },
    RoletaDaSorteEzg: {
      href: "/casino/ezg-roleta-da-sorte",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/RoletaDaSorte.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Roleta Da Sorte",
      gameType: gameTypes.new,
    },
    // RuletaAEzg: {
    //   href: "/casino/ezg-ruleta-a",
    //   code: "",
    //   casino: "ezugi",
    //   category: "roulette",
    //   provider: "ezugi",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/roulette/ezugi/RuletaA.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "",
    //   name: "Ruleta A",
    //   gameType: gameTypes.new, // },
    RuletaDelSolEzg: {
      href: "/casino/ezg-ruleta-del-sol",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/RuletaDelSol.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Ruleta Del Sol",
      gameType: gameTypes.new,
    },
    RussianRouletteEzg: {
      href: "/casino/ezg-russian-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/RussianRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Russian Roulette",
      gameType: gameTypes.popular,
    },
    SkylineRouletteEzg: {
      href: "/casino/ezg-skyline-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SkylineRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Skyline Roulette",
      gameType: gameTypes.new,
    },
    SpanishRouletteEzg: {
      href: "/casino/ezg-spanish-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SpanishRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Spanish Roulette",
      gameType: gameTypes.popular,
    },
    SpeedAutoRouletteEzg: {
      href: "/casino/ezg-speed-auto-roulette",
      code: "221002",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SpeedAutoRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Speed Auto Roulette",
      gameType: gameTypes.popular,
    },
    SpeedRouletteEzg: {
      href: "/casino/ezg-speed-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/SpeedRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Speed Roulette",
      gameType: gameTypes.popular,
    },
    TurkishRouletteEzg: {
      href: "/casino/ezg-turkish-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/TurkishRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Turkish Roulette",
      gameType: gameTypes.popular,
    },
    UltimateRouletteEzg: {
      href: "/casino/ezg-ultimate-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/UltimateRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Ultimate Roulette",
      gameType: gameTypes.popular,
    },
    VIPRouletteEzg: {
      href: "/casino/ezg-vip-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/VIPRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "VIP Roulette",
      gameType: gameTypes.popular,
    },

    AmericanRouletteEvo: {
      href: "/casino/ezgevo-american-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/AmericanRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "American Roulette",
      gameType: gameTypes.popular,
    },
    AutoRouletteEvo: {
      href: "/casino/ezgevo-auto-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/AutoRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Auto Roulette",
      gameType: gameTypes.popular,
    },
    DoubleBallRouletteEvo: {
      href: "/casino/ezgevo-double-ball-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/DoubleBallRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Double Ball Roulette",
      gameType: gameTypes.new,
    },
    DragonaraRouletteEvo: {
      href: "/casino/ezgevo-dragonara-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/DragonaraRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Dragonara Roulette",
      gameType: gameTypes.new,
    },
    FirstPersonAmericanRouletteEvo: {
      href: "/casino/ezgevo-first-person-american-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/FirstPersonAmericanRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "First Person American Roulette",
      gameType: gameTypes.new,
    },
    FootballStudioRouletteEvo: {
      href: "/casino/ezgevo-football-studio-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/FootballStudioRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Football Studio Roulette",
      gameType: gameTypes.new,
    },
    InstantRouletteEvo: {
      href: "/casino/ezgevo-instant-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/InstantRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Instant Roulette",
      gameType: gameTypes.new,
    },
    LightningRouletteEvo: {
      href: "/casino/ezgevo-lightning-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/LightningRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Lightning Roulette",
      gameType: gameTypes.popular,
    },
    RoulettEvo: {
      href: "/casino/ezgevo-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/Roulett.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Roulett",
      gameType: gameTypes.popular,
    },
    SpeedAutoRouletteEvo: {
      href: "/casino/ezgevo-speed-auto-roulette",
      code: "1000103",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/SpeedAutoRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Speed Auto Roulette-EVO",
      gameType: gameTypes.popular,
    },
    SpeedRouletteEvo: {
      href: "/casino/ezgevo-speed-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/SpeedRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Speed Roulette",
      gameType: gameTypes.popular,
    },
    TurkishLightningRouletteEvo: {
      href: "/casino/ezgevo-turkish-lightning-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/TurkishLightningRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Turkish Lightning Roulette",
      gameType: gameTypes.popular,
    },
    VIPRouletteEvo: {
      href: "/casino/ezgevo-vip-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/VipRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "VIP Roulette",
      gameType: gameTypes.popular,
    },
    XxxtremeLightningRouletteEvo: {
      href: "/casino/ezgevo-xxxtreme-lightning-roulette",
      code: "",
      casino: "ezugi",
      category: "roulette",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/XxxtremeLightningRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Xxxtreme Lightning Roulette",
      gameType: gameTypes.popular,
    },

    RouletteAura: {
      href: "/casino/aura-roulette",
      code: "",
      casino: "aura",
      category: "roulette",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/aura/Roulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Roulette",
      gameType: gameTypes.popular,
    },

    EuropeanAutoRouletteVivo: {
      href: "/casino/vivo-european-auto-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/EuropeanAutoRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "European Auto Roulette",
      gameType: gameTypes.new,
    },
    FrenchRouletteVivo: {
      href: "/casino/vivo-french-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/FrenchRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "French Roulette",
      gameType: gameTypes.new,
    },
    GalaxyRouletteVivo: {
      href: "/casino/vivo-galaxy-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/GalaxyRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Galaxy Roulette",
      gameType: gameTypes.popular,
    },
    LasVegasRouletteVivo: {
      href: "/casino/vivo-las-vegas-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/LasVegasRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "las vegas roulette",
      name: "Las Vegas Roulette",
      gameType: gameTypes.popular,
    },
    Oracle360RouletteVivo: {
      href: "/casino/vivo-oracle-360-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/Oracle360Roulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Oracle 360 Roulette",
      gameType: gameTypes.popular,
    },
    OracleBlazeRouletteVivo: {
      href: "/casino/vivo-oracle-blaze-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/OracleBlazeRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "oracle blaze roulette",
      name: "Oracle Blaze Roulette",
      gameType: gameTypes.popular,
    },
    PortomasoRouletteVivo: {
      href: "/casino/vivo-portomaso-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/PortomasoRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "vivo portomaso roulette",
      name: "Vivo Portomaso Roulette",
      gameType: gameTypes.popular,
    },
    VARouletteVivo: {
      href: "/casino/vivo-va-roulette",
      code: "",
      casino: "vivo",
      category: "roulette",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/VARoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "VA Roulette",
      gameType: gameTypes.new,
    },

    // RouletteSn: {
    //   href: "/casino/sn-roulette",
    //   code: "",
    //   casino: "wco",
    //   category: "roulette",
    //   provider: "supernowa",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/roulette/supernowa/Roulette.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "",
    //   name: "Roulette",
    //   gameType: gameTypes.popular, // },

    EuropeanRouletteKM: {
      href: "/casino/km-european-roulette",
      code: "",
      casino: "",
      category: "roulette",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/roulette/european-roulette.webp",
      plaBtn: "./images/play-btn.png",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "European Roulette",
      gameType: gameTypes.popular,
    },
    FruitRouletteKM: {
      href: "/casino/km-fruit-roulette",
      code: "",
      casino: "",
      category: "roulette",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/roulette/fruit-roulette.webp",
      plaBtn: "./images/play-btn.png",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "FruitRoulette",
      gameType: gameTypes.popular,
    },
    MonkeyKingRouletteKM: {
      href: "/casino/km-monkey-king-roulette",
      code: "",
      casino: "",
      category: "roulette",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/roulette/monkey-king-roulette.webp",
      plaBtn: "./images/play-btn.png",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Monkey King Roulette",
      gameType: gameTypes.new,
    },
    PokerRouletteKM: {
      href: "/casino/km-poker-roulette",
      code: "",
      casino: "",
      category: "roulette",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/roulette/poker-roulette.webp",
      plaBtn: "./images/play-btn.png",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Poker Roulette",
      gameType: gameTypes.popular,
    },

    RouletteAes: {
      href: "/casino/awc-roulette",
      code: "",
      casino: "AE Sexy",
      category: "roulette",
      provider: "Worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/aesexy/Roulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Roulette",
      name: "Roulette",
      gameType: gameTypes.popular,
    },
  },

  andarbahar: {
    AndarBaharEzg: {
      href: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      category: "andarbahar",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/AndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      gameType: gameTypes.popular,
    },
    OTTAndarBaharEzg: {
      href: "/casino/ezg-casino-marina-andar-bahar",
      code: "328000",
      casino: "ezugi",
      category: "andarbahar",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/OTTAndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "OTT Andar Bahar",
      name: "OTT Andar Bahar",
      gameType: gameTypes.popular,
    },
    UltimateAndarBaharEzg: {
      href: "/casino/ezg-ultimate-andar-bahar",
      code: "328000",
      casino: "ezugi",
      category: "andarbahar",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/UltimateAndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Ultimate Andar Bahar",
      name: "Ultimate Andar Bahar",
      gameType: gameTypes.popular,
    },

    AndarBaharAura: {
      href: "/casino/aura-andar-bahar",
      code: "",
      casino: "aura",
      category: "andarbahar",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/aura/AndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      gameType: gameTypes.new,
    },
    AndarBaharVirtualAura: {
      href: "/casino/aura-andar-bahar-virtual",
      code: "",
      casino: "aura",
      category: "andarbahar",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/aura/AndarBaharVirtual.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Andar Bahar (Virtual)",
      name: "Andar Bahar (Virtual)",
      gameType: gameTypes.new,
    },

    AndarBaharVivo: {
      href: "/casino/vivo-andar-bahar",
      code: "",
      casino: "vivo",
      category: "andarbahar",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/Vivo/AndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "andar bahar",
      name: "Andar Bahar",
      gameType: gameTypes.popular,
    },

    AndarBaharSn: {
      href: "/casino/sn-andar-bahar",
      code: "",
      casino: "wco",
      category: "andarbahar",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/AndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      gameType: gameTypes.new,
    },
    ClassicAndarBaharSn: {
      href: "/casino/sn-classic-andar-bahar",
      code: "",
      casino: "wco",
      category: "andarbahar",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/ClassicAndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Classic Andar Bahar",
      name: "Classic Andar Bahar",
      gameType: gameTypes.popular,
    },
    GoasAndarBaharSn: {
      href: "/casino/sn-goas-andar-bahar",
      code: "",
      casino: "wco",
      category: "andarbahar",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/supernowa/Goa'sAndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Goa's Andar Bahar",
      name: "Goa's Andar Bahar",
      gameType: gameTypes.new,
    },
    // RNGAndarBahar2020Sn: {
    //   href: "/casino/sn-rng-andar-bahar-2020",
    //   code: "",
    //   casino: "wco",
    //   category: "andarbahar",
    //   provider: "supernowa",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/andarbahar/supernowa/RNGAndarBahar2020.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "RNG Andar Bahar 2020",
    //   name: "RNG Andar Bahar 2020",
    //   gameType: gameTypes.new,
    // },

    AndarBaharKM: {
      href: "/casino/km-andar-bahar",
      code: "",
      casino: "",
      category: "andarbahar",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/andar-bahar/andar-bahar.webp",
      plaBtn: "./images/play-btn.png",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Andar Bahar",
      gameType: gameTypes.popular,
    },

    ExtraAndarBaharAes: {
      href: "/casino/awc-extra-andar-bahar",
      code: "",
      casino: "AE Sexy",
      category: "andarbahar",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/aesexy/AndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Extra Andar Bahar",
      name: "Extra Andar Bahar",
      gameType: gameTypes.new,
    },
  },

  livecasino: {
    BuffaloWin: {
      href: "/casino/aggappgsoft-buffalo-win",
      code: "328000",
      casino: "ezugi",
      category: "livecasino",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/BuffaloWin.jpg",
      plaBtn: "./images/play-btn.png",
      alt: "Buffalo Win",
      name: "Buffalo Win",
      gameType: gameTypes.popular,
    },
    SakuraFortune: {
      href: "/casino/aggapplaytech-sakura-fortune",
      code: "328000",
      casino: "ezugi",
      category: "livecasino",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/SakuraFortune.jpg",
      plaBtn: "./images/play-btn.png",
      alt: "Sakura Fortune",
      name: "Sakura Fortune",
      gameType: gameTypes.popular,
    },
    TowerX: {
      href: "/casino/aggapsmartsoftgaming-towerx",
      code: "328000",
      casino: "ezugi",
      category: "livecasino",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/TowerX.png",
      plaBtn: "./images/play-btn.png",
      alt: "TowerX",
      name: "TowerX",
      gameType: gameTypes.popular,
    },
    MonopolyBigballer: {
      href: "/casino/ezgevo-monopoly-big-baller",
      code: "328000",
      casino: "ezugi",
      category: "livecasino",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/MonopolyBigBaller.jpg",
      plaBtn: "./images/play-btn.png",
      alt: "MONOPOLY Big Baller",
      name: "MONOPOLY Big Baller",
      gameType: gameTypes.popular,
    },
    CrazyTimeEvo: {
      href: "/casino/ezgevo-crazy-time",
      code: "",
      casino: "evolution",
      category: "livecasino",
      provider: "Evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/CrazyTime1.jpg",
      plaBtn: "./images/play-btn.png",
      alt: "crazy time",
      name: "Crazy Time",
      gameType: gameTypes.popular,
    },
    MonopolyLive: {
      href: "/casino/ezgevo-monopoly-live",
      code: "328000",
      casino: "ezugi",
      category: "livecasino",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/tvshows/Monopoly.jpg",
      plaBtn: "./images/play-btn.png",
      alt: "Monopoly",
      name: "Monopoly",
      gameType: gameTypes.popular,
    },
    // GoldenGenie: {
    //   href: "/casino/qtechfachai-golden-genie-u3448",
    //   code: "328000",
    //   casino: "ezugi",
    //   category: "livecasino",
    //   provider: "Qtech",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/tvshows/goldengenie.jpg",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "Golden Genie",
    //   name: "Golden Genie",
    //   gameType: gameTypes.popular,
    // },
    AndarBaharEzgLC: {
      href: "/casino/ezg-andar-bahar",
      code: "328000",
      casino: "ezugi",
      category: "livecasino",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/andarbahar/ezugi/AndarBahar.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Andar Bahar",
      name: "Andar Bahar",
      gameType: gameTypes.popular,
    },
    LightningRouletteEvoLC: {
      href: "/casino/ezgevo-lightning-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "livecasino",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/evolution/LightningRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Lightning Roulette",
      gameType: gameTypes.popular,
    },
    GodOfWealthLC: {
      href: "/casino/ezgrt-god-of-wealth",
      code: "1100001",
      casino: "ezugi",
      category: "livecasino",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/GodOfWealth.webp",
      plaBtn: "./images/play-btn.png",
      alt: "God Of Wealth",
      name: "God Of Wealth",
      gameType: gameTypes.new,
    },
    UltimateRouletteEzgLC: {
      href: "/casino/ezg-ultimate-roulette",
      code: "1000148",
      casino: "ezugi",
      category: "livecasino",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/ezugi/UltimateRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Ultimate Roulette",
      gameType: gameTypes.popular,
    },
    LasVegasRouletteVivoLC: {
      href: "/casino/vivo-las-vegas-roulette",
      code: "",
      casino: "vivo",
      category: "livecasino",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/roulette/vivo/LasVegasRoulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "las vegas roulette",
      name: "Las Vegas Roulette",
      gameType: gameTypes.popular,
    },
    LuckyFortuneCatLC: {
      href: "/casino/ezgrt-lucky-fortune-cat",
      code: "1100001",
      casino: "ezugi",
      category: "livecasino",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/LuckyFortuneCat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Lucky Fortune Cat",
      name: "Lucky Fortune Cat",
      gameType: gameTypes.popular,
    },
    SuperSicboEvoLC: {
      href: "/casino/ezgevo-super-sic-bo",
      code: "",
      casino: "ezugi",
      category: "livecasino",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/dice/SuperSicBo.jpg",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Super Sic Bo",
      gameType: gameTypes.popular,
    },
    KnockoutBaccaratEzgLC: {
      href: "/casino/ezg-knockout-baccarat",
      code: "",
      casino: "ezugi",
      category: "livecasino",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/KnockoutBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Knockout Baccarat",
      name: "Knockout Baccarat",
      gameType: gameTypes.popular,
    },
    LightningBaccaratEvoLC: {
      href: "/casino/ezgevo-lightning-baccarat",
      code: "",
      casino: "ezugi",
      category: "livecasino",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/LightningBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Lightning Baccarat",
      name: "Lightning Baccarat",
      gameType: gameTypes.popular,
    },
    GonzosTreasureHuntLC: {
      href: "/casino/ezgne-gonzos-treasure-hunt",
      code: "",
      casino: "ezugi",
      category: "livecasino",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/GonzosTreasureHunt.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gonzos Treasure Hunt",
      name: "Gonzos Treasure Hunt",
      gameType: gameTypes.popular,
    },
    GorillaKingdom: {
      href: "/casino/ezgne-gorilla-kingdom",
      code: "1100088",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/GorillaKingdom.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gorilla Kingdom",
      name: "Gorilla Kingdom",
      gameType: gameTypes.livecasino,
    },
    PiggyRiches: {
      href: "/casino/ezgne-piggy-riches",
      code: "1100080",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/PiggyRiches.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Piggy Riches",
      name: "Piggy Riches",
      gameType: gameTypes.livecasino,
    },
    PiggyRiches: {
      href: "/casino/qtechskywindlive-live-jokers-wheel",
      code: "1100080",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/jokerwheel.jpg",
      plaBtn: "./images/play-btn.png",
      alt: "jokers wheel",
      name: "jokers Wheel",
      gameType: gameTypes.livecasino,
    },
  },

  slots: {
    Christmas: {
      href: "/casino/ezgne-aloha-christmas",
      code: "1100032",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/AlohaChristmas.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Aloha! Christmas",
      name: "Aloha! Christmas",
      gameType: gameTypes.new,
    },
    BloodSuckers: {
      href: "/casino/ezgne-blood-suckers",
      code: "",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/BloodSuckers.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blood Suckers",
      name: "Blood Suckers",
      gameType: gameTypes.popular,
    },
    ButterflyStaxx: {
      href: "/casino/ezgne-butterfly-staxx",
      code: "",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/ButterflyStaxx.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Butterfly Staxx",
      name: "Butterfly Staxx",
      gameType: gameTypes.new,
    },
    GonzosTreasureHunt: {
      href: "/casino/ezgne-gonzos-treasure-hunt",
      code: "",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/GonzosTreasureHunt.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gonzos Treasure Hunt",
      name: "Gonzos Treasure Hunt",
      gameType: gameTypes.popular,
    },
    GorillaKingdom: {
      href: "/casino/ezgne-gorilla-kingdom",
      code: "1100088",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/GorillaKingdom.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gorilla Kingdom",
      name: "Gorilla Kingdom",
      gameType: gameTypes.popular,
    },
    PiggyRiches: {
      href: "/casino/ezgne-piggy-riches",
      code: "1100080",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/PiggyRiches.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Piggy Riches",
      name: "Piggy Riches",
      gameType: gameTypes.new,
    },
    ReelRush: {
      href: "/casino/ezgne-reel-rush",
      code: "",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/ReelRush.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Reel Rush",
      name: "Reel Rush",
      gameType: gameTypes.popular,
    },
    RomeTheGoldenAge: {
      href: "/casino/ezgne-rome-the-golden-age",
      code: "",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/RomeTheGoldenAge.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Rome The Golden Age",
      name: "Rome The Golden Age",
      gameType: gameTypes.new,
    },
    SteamTower: {
      href: "/casino/ezgne-steam-tower",
      code: "1100043",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/SteamTower.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Steam Tower",
      name: "Steam Tower",
      gameType: gameTypes.new,
    },
    TurnYourFortune: {
      href: "/casino/ezgne-turn-your-fortune",
      code: "1100041",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/TurnYourFortune.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Turn Your Fortune",
      name: "Turn Your Fortune",
      gameType: gameTypes.popular,
    },
    TwinSpinMegaways: {
      href: "/casino/ezgne-twin-spin-megaways",
      code: "1100039",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/netent/TwinSpinMegaways.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Twin Spin Megaways",
      name: "Twin Spin Megaways",
      gameType: gameTypes.popular,
    },
    Nights10001: {
      href: "/casino/ezgrt-10001-nights",
      code: "",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/10,001Nights.webp",
      plaBtn: "./images/play-btn.png",
      alt: "10,001 Nights",
      name: "10,001 Nights",
      gameType: gameTypes.popular,
    },
    AncientsBlessing: {
      href: "/casino/ezgrt-ancients-blessing",
      code: "",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/AncientsBlessing.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Ancients Blessing",
      name: "Ancients Blessing",
      gameType: gameTypes.new,
    },
    AurumCodex: {
      href: "/casino/ezgrt-aurum-codex",
      code: "",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/AurumCodex.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Aurum Codex",
      name: "Aurum Codex",
      gameType: gameTypes.new,
    },
    ChineseTreasures: {
      href: "/casino/ezgrt-chinese-treasures",
      code: "",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/ChineseTreasures.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Chinese Treasures",
      name: "Chinese Treasures",
      gameType: gameTypes.popular,
    },
    DragonLuck: {
      href: "/casino/ezgrt-dragons-luck",
      code: "1100001",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/DragonsLuck.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dragon's Luck",
      name: "Dragon's Luck",
      gameType: gameTypes.popular,
    },
    EpicJourney: {
      href: "/casino/ezgrt-epic-journey",
      code: "1100001",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/EpicJourney.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Epic Journey",
      name: "Epic Journey",
      gameType: gameTypes.new,
    },
    FortuneHouse: {
      href: "/casino/ezgrt-fortune-house",
      code: "1100001",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/FortuneHouse.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Fortune House",
      name: "Fortune House",
      gameType: gameTypes.popular,
    },
    GodOfWealth: {
      href: "/casino/ezgrt-god-of-wealth",
      code: "1100001",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/GodOfWealth.webp",
      plaBtn: "./images/play-btn.png",
      alt: "God Of Wealth",
      name: "God Of Wealth",
      gameType: gameTypes.new,
    },
    LuckyFortuneCat: {
      href: "/casino/ezgrt-lucky-fortune-cat",
      code: "1100001",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/LuckyFortuneCat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Lucky Fortune Cat",
      name: "Lucky Fortune Cat",
      gameType: gameTypes.popular,
    },
    MagicGate: {
      href: "/casino/ezgrt-magic-gate",
      code: "1100001",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/MagicGate.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Magic Gate",
      name: "Magic Gate",
      gameType: gameTypes.new,
    },
    MegaPyramid: {
      href: "/casino/ezgrt-mega-pyramid",
      code: "1100001",
      casino: "ezugi",
      category: "slots",
      provider: "slots",
      homeUrl: pageUrlGenerator("/slots"),
      imgUrl: "./images/slots/redtiger/MegaPyramid.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Mega Pyramid",
      name: "Mega Pyramid",
      gameType: gameTypes.new,
    },
  },

  baccarat: {
    Baccarat: {
      href: "/casino/ezg-baccarat",
      code: "101",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/Baccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Baccarat",
      gameType: gameTypes.popular,
    },
    BaccaratEEzg: {
      href: "/casino/ezg-baccarat-e",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/BaccaratE.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat E",
      name: "Baccarat E",
      gameType: gameTypes.popular,
    },
    CasinoMarinaBaccarat1Ezg: {
      href: "/casino/ezg-casino-marina-baccarat-1",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Casino Marina Baccarat 1",
      name: "Casino Marina Baccarat 1",
      gameType: gameTypes.new,
    },
    CasinoMarinaBaccarat2Ezg: {
      href: "/casino/ezg-casino-marina-baccarat-2",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat2.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Casino Marina Baccarat 2",
      name: "Casino Marina Baccarat 2",
      gameType: gameTypes.new,
    },
    CasinoMarinaBaccarat3Ezg: {
      href: "/casino/ezg-casino-marina-baccarat-3",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat3.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Casino Marina Baccarat 3",
      name: "Casino Marina Baccarat 3",
      gameType: gameTypes.new,
    },
    CasinoMarinaBaccarat4Ezg: {
      href: "/casino/ezg-casino-marina-baccarat-4",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/CasinoMarinaBaccarat4.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Casino Marina Baccarat 4",
      name: "Casino Marina Baccarat 4",
      gameType: gameTypes.new,
    },
    FortuneBaccarat: {
      href: "/casino/ezg-fortune-baccarat",
      code: "101",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/FortuneBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Fortune Baccarat",
      name: "Fortune Baccarat",
      gameType: gameTypes.popular,
    },
    KnockoutBaccaratEzg: {
      href: "/casino/ezg-knockout-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/KnockoutBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Knockout Baccarat",
      name: "Knockout Baccarat",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratAEzg: {
      href: "/casino/ezg-no-commission-baccarat-a",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratA.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat A",
      name: "No Commission Baccarat A",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratBEzg: {
      href: "/casino/ezg-no-commission-baccarat-b",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratB.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat B",
      name: "No Commission Baccarat B",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratCEzg: {
      href: "/casino/ezg-no-commission-baccarat-c",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratC.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat C",
      name: "No Commission Baccarat C",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratDEzg: {
      href: "/casino/ezg-no-commission-baccarat-d",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratD.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat D",
      name: "No Commission Baccarat D",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratEEzg: {
      href: "/casino/ezg-no-commission-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionBaccaratE.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat E",
      name: "No Commission Baccarat E",
      gameType: gameTypes.popular,
    },
    NoCommissionOverUnderBaccaratEzg: {
      href: "/casino/ezg-no-commission-over-under-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/NoCommissionOverUnderBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Over Under Baccarat",
      name: "No Commission Over Under Baccarat",
      gameType: gameTypes.new,
    },
    OverUnderBaccaratEzg: {
      href: "/casino/ezg-over-under-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/OverUnderBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Over Under Baccarat",
      name: "Over Under Baccarat",
      gameType: gameTypes.new,
    },
    // SpeedCricketBaccarat: {
    //   href: "/casino/ezg-speed-cricket-baccarat",
    //   code: "101",
    //   casino: "ezugi",
    //   category: "baccarat",
    //   provider: "ezugi",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/Speedcricketbaccarat.jpg",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "Speed Cricket Baccarat",
    //   name: "Speed Cricket Baccarat",
    //   gameType: gameTypes.popular,
    // },
    SpeedFortuneBaccaratEzg: {
      href: "/casino/ezg-speed-fortune-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/SpeedFortuneBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Fortune Baccarat",
      name: "Speed Fortune Baccarat",
      gameType: gameTypes.popular,
    },
    Super6BaccaratEzg: {
      href: "/casino/ezg-super-6-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/Super6Baccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Super 6 Baccarat",
      name: "Super 6 Baccarat",
      gameType: gameTypes.popular,
    },
    VIPFortuneBaccaratEzg: {
      href: "/casino/ezg-vip-fortune-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/ezugi/VIPFortuneBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VIP Fortune Baccarat",
      name: "VIP Fortune Baccarat",
      gameType: gameTypes.popular,
    },
    // VIPNoCommissionSpeedCricketBaccaratEzg: {
    //   href: "/casino/ezg-vip-no-commission-speed-cricket-baccarat",
    //   code: "",
    //   casino: "ezugi",
    //   category: "baccarat",
    //   provider: "ezugi",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/ezugi/VIPNoCommissionSpeedCricketBaccarat.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "VIP No Commission Speed Cricket Baccarat",
    //   name: "VIP No Commission Speed Cricket Baccarat",
    //   gameType: gameTypes.popular,
    // },

    BaccaratBEvo: {
      href: "/casino/ezgevo-baccarat-b",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/BaccaratB.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat B",
      name: "Baccarat B",
      gameType: gameTypes.popular,
    },
    // BaccaratCEvo: {
    //   href: "/casino/ezgevo-baccarat-c",
    //   code: "",
    //   casino: "ezugi",
    //   category: "baccarat",
    //   provider: "evolution",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/baccarat/evolution/BaccaratC.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "Baccarat C",
    //   name: "Baccarat C",
    //   gameType: gameTypes.popular,
    // },
    BaccaratSqueezeEvo: {
      href: "/casino/ezgevo-baccarat-squeeze",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/BaccaratSqueeze.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat Squeeze",
      name: "Baccarat Squeeze",
      gameType: gameTypes.new,
    },
    FirstPersonBaccaratEvo: {
      href: "/casino/ezgevo-first-person-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/FirstPersonBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "First Person Baccarat",
      name: "First Person Baccarat",
      gameType: gameTypes.popular,
    },
    FirstPersonGoldenWealthBaccaratEvo: {
      href: "/casino/ezgevo-first-person-golden-wealth-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl:
        "./images/baccarat/evolution/FirstPersonGoldenWealthBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "First Person Golden Wealth Baccarat",
      name: "First Person Golden Wealth Baccarat",
      gameType: gameTypes.new,
    },
    FirstPersonLightningBaccaratEvo: {
      href: "/casino/ezgevo-first-person-lightning-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/FirstPersonLightningBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "First Person Lightning Baccarat",
      name: "First Person Lightning Baccarat",
      gameType: gameTypes.popular,
    },
    GoldenWealthBaccaratEvo: {
      href: "/casino/ezgevo-golden-wealth-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/GoldenWealthBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Golden Wealth Baccarat",
      name: "Golden Wealth Baccarat",
      gameType: gameTypes.new,
    },
    LightningBaccaratEvo: {
      href: "/casino/ezgevo-lightning-baccarat",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/LightningBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Lightning Baccarat",
      name: "Lightning Baccarat",
      gameType: gameTypes.popular,
    },
    NoCommissionBaccaratEvo: {
      href: "/casino/ezgevo-no-commission-baccarat-evo",
      code: "1000018",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/NoCommissionBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "No Commission Baccarat",
      name: "No Commission Baccarat",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratAEvo: {
      href: "/casino/ezgevo-speed-baccarat-a",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratA.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat A",
      name: "Speed Baccarat A",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratBEvo: {
      href: "/casino/ezgevo-speed-baccarat-b",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratB.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat B",
      name: "Speed Baccarat B",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratCEvo: {
      href: "/casino/ezgevo-speed-baccarat-c",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratC.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat C",
      name: "Speed Baccarat C",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratDEvo: {
      href: "/casino/ezgevo-speed-baccarat-d",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratD.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat D",
      name: "Speed Baccarat D",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratEEvo: {
      href: "/casino/ezgevo-speed-baccarat-e",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratE.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat E",
      name: "Speed Baccarat E",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratFEvo: {
      href: "/casino/ezgevo-speed-baccarat-f",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratF.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat F",
      name: "Speed Baccarat F",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratGEvo: {
      href: "/casino/ezgevo-speed-baccarat-g",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratG.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat G",
      name: "Speed Baccarat G",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratHEvo: {
      href: "/casino/ezgevo-speed-baccarat-h",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratH.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat H",
      name: "Speed Baccarat H",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratIEvo: {
      href: "/casino/ezgevo-speed-baccarat-i",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratI.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat I",
      name: "Speed Baccarat I",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratJEvo: {
      href: "/casino/ezgevo-speed-baccarat-j",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratJ.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat J",
      name: "Speed Baccarat J",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratREvo: {
      href: "/casino/ezgevo-speed-baccarat-r",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratR.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat R",
      name: "Speed Baccarat R",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratVEvo: {
      href: "/casino/ezgevo-speed-baccarat-v",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratV.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat V",
      name: "Speed Baccarat V",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratWEvo: {
      href: "/casino/ezgevo-speed-baccarat-w",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratW.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat W",
      name: "Speed Baccarat W",
      gameType: gameTypes.popular,
    },
    SpeedBaccaratXEvo: {
      href: "/casino/ezgevo-speed-baccarat-x",
      code: "",
      casino: "ezugi",
      category: "baccarat",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/evolution/SpeedBaccaratX.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Baccarat X",
      name: "Speed Baccarat X",
      gameType: gameTypes.popular,
    },

    BaccaratAura: {
      href: "/casino/aura-baccarat",
      code: "",
      casino: "aura",
      category: "baccarat",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/aura/Baccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat",
      name: "Baccarat",
      gameType: gameTypes.new,
    },
    Card29BaccaratAura: {
      href: "/casino/aura-29-card-baccarat",
      code: "",
      casino: "aura",
      category: "baccarat",
      provider: "aura",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/aura/29CardBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "29 Card Baccarat",
      name: "29 Card Baccarat",
      gameType: gameTypes.new,
    },

    GalaxyBaccarat1Vivo: {
      href: "/casino/vivo-galaxy-baccarat-1",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/GalaxyBaccarat1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Galaxy Baccarat 1",
      name: "Galaxy Baccarat 1",
      gameType: gameTypes.new,
    },
    GalaxyBaccarat2Vivo: {
      href: "/casino/vivo-galaxy-baccarat-2",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/GalaxyBaccarat2.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Galaxy Baccarat 2",
      name: "Galaxy Baccarat 2",
      gameType: gameTypes.new,
    },
    GalaxyBaccarat3Vivo: {
      href: "/casino/vivo-galaxy-baccarat-3",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/GalaxyBaccarat3.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Galaxy Baccarat 3",
      name: "Galaxy Baccarat 3",
      gameType: gameTypes.new,
    },
    MacauBaccaratVivo: {
      href: "/casino/vivo-macau-baccarat",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Macau Baccarat",
      name: "Macau Baccarat",
      gameType: gameTypes.new,
    },
    VABacarat1Vivo: {
      href: "/casino/vivo-va-bacarat-1",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VA Bacarat 1",
      name: "VA Bacarat 1",
      gameType: gameTypes.popular,
    },
    VABacarat2Vivo: {
      href: "/casino/vivo-va-bacarat-2",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VA Bacarat 2",
      name: "VA Bacarat 2",
      gameType: gameTypes.popular,
    },
    VABacarat3Vivo: {
      href: "/casino/vivo-va-bacarat-3",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VA Bacarat 3",
      name: "VA Bacarat 3",
      gameType: gameTypes.popular,
    },
    VABacarat4Vivo: {
      href: "/casino/vivo-va-bacarat-4",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VA Bacarat 4",
      name: "VA Bacarat 4",
      gameType: gameTypes.popular,
    },
    VABacarat5Vivo: {
      href: "/casino/vivo-va-bacarat-5",
      code: "",
      casino: "vivo",
      category: "baccarat",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/vivo/MacauBaccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VA Bacarat 5",
      name: "VA Bacarat 5",
      gameType: gameTypes.popular,
    },

    BaccaratSn: {
      href: "/casino/sn-baccarat",
      code: "",
      casino: "wco",
      category: "baccarat",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/supernowa/Baccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat",
      name: "Baccarat",
      gameType: gameTypes.new,
    },
    RNGBaccaratSn: {
      href: "/casino/sn-rng-baccarat",
      code: "",
      casino: "wco",
      category: "baccarat",
      provider: "supernowa",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/baccarat/supernowa/Baccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "RNG Baccarat",
      name: "RNG Baccarat",
      gameType: gameTypes.new,
    },
    // RNGBaccarat2020Sn: {
    //   href: "/casino/sn-rng-baccarat-2020",
    //   code: "",
    //   casino: "wco",
    //   category: "baccarat",
    //   provider: "supernowa",
    //   homeUrl: "http://localhost:3000/Casino",
    //   plaBtn: "./images/play-btn.png",  imgUrl: "./images/baccarat/supernowa/RNGBaccarat2020.webp",
    //   alt: "RNG Baccarat 2020",
    //   name: "RNG Baccarat 2020",
    //   gameType: gameTypes.new,
    // },

    BaccaratKM: {
      href: "/casino/km-baccarat",
      code: "",
      casino: "",
      category: "baccarat",
      provider: "kingmaker",
      imgUrl: "./images/kingmaker/baccarat/baccarat.webp",
      homeUrl: pageUrlGenerator("/kingmaker"),
      name: "Baccarat",
      plaBtn: "./images/play-btn.png",
      gameType: gameTypes.new,
    },

    BaccaratAes: {
      href: "/casino/awc-baccarat",
      code: "",
      casino: "AE Sexy",
      category: "baccarat",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/aesexy/Baccarat.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat",
      name: "Baccarat",
      gameType: gameTypes.popular,
    },
    BaccaratClassicAes: {
      href: "/casino/awc-baccarat-classic",
      code: "",
      casino: "AE Sexy",
      category: "baccarat",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/aesexy/BaccaratClassic.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Baccarat Classic",
      name: "Baccarat Classic",
      gameType: gameTypes.new,
    },
  },

  blackjack: {
    // BlackjackAEzg: {
    //   href: "/casino/ezg-blackjack-a",
    //   code: "",
    //   casino: "ezugi",
    //   category: "blackjack",
    //   provider: "ezugi",
    //   homeUrl: "http://localhost:3000/Casino",
    //   imgUrl: "./images/blackjack/ezugi/BlackjackA.webp",
    //   plaBtn: "./images/play-btn.png",
    //   alt: "Blackjack A",
    //   name: "Blackjack A",
    //   gameType: gameTypes.popular,
    // },
    BlackjackDaSorteEzg: {
      href: "/casino/ezg-blackjack-da-sorte",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/BlackjackDaSorte.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack Da Sorte",
      name: "Blackjack Da Sorte",
      gameType: gameTypes.new,
    },
    GoldBlackjack1Ezg: {
      href: "/casino/ezg-gold-blackjack-1",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/GoldBlackjack1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gold Blackjack 1",
      name: "Gold Blackjack 1",
      gameType: gameTypes.popular,
    },
    GoldBlackjack3Ezg: {
      href: "/casino/ezg-gold-blackjack-3",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/GoldBlackjack3.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gold Blackjack 3",
      name: "Gold Blackjack 3",
      gameType: gameTypes.popular,
    },
    Rumbablackjack1Ezg: {
      href: "/casino/ezg-rumba-blackjack-1",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/RumbaBlackjack1.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Rumba Blackjack 1",
      name: "Rumba Blackjack 1",
      gameType: gameTypes.new,
    },
    Rumbablackjack4Ezg: {
      href: "/casino/ezg-rumba-blackjack-4",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/RumbaBlackjack4.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Rumba Blackjack 4",
      name: "Rumba Blackjack 4",
      gameType: gameTypes.new,
    },
    SpanishUnlimitedBlackjackEzg: {
      href: "/casino/ezg-spanish-unlimited-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/SpanishUnlimitedBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Spanish Unlimited Blackjack",
      name: "Spanish Unlimited Blackjack",
      gameType: gameTypes.new,
    },
    UnlimitedBlackjackEzg: {
      href: "/casino/ezg-unlimited-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/UnlimitedBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Unlimited Blackjack",
      name: "Unlimited Blackjack",
      gameType: gameTypes.popular,
    },
    VIPDiamondBlackjackEzg: {
      href: "/casino/ezg-vip-diamond-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/VIPDiamondBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "VIP Diamond Blackjack",
      name: "VIP Diamond Blackjack",
      gameType: gameTypes.popular,
    },
    VipSurrenderBlackjackEzg: {
      href: "/casino/ezg-vip-surrender-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "ezugi",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/ezugi/VipSurrenderBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Vip Surrender Blackjack",
      name: "Vip Surrender Blackjack",
      gameType: gameTypes.popular,
    },

    BlackjackAEvo: {
      href: "/casino/ezgevo-blackjack-a",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackA.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack A",
      name: "Blackjack A",
      gameType: gameTypes.popular,
    },
    BlackjackPartyEvo: {
      href: "/casino/ezgevo-blackjack-party",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackParty.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack Party",
      name: "Blackjack Party",
      gameType: gameTypes.new,
    },
    BlackjackSilverAEvo: {
      href: "/casino/ezgevo-blackjack-silver-a",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackSilverA.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack Silver A",
      name: "Blackjack Silver A",
      gameType: gameTypes.new,
    },
    BlackjackVIP10Evo: {
      href: "/casino/ezgevo-blackjack-vip-10",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIP10.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP 10",
      name: "Blackjack VIP 10",
      gameType: gameTypes.popular,
    },
    BlackjackVIPAlphaEvo: {
      href: "/casino/ezgevo-blackjack-vip-alpha",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPAlpha.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP Alpha",
      name: "Blackjack VIP Alpha",
      gameType: gameTypes.popular,
    },
    BlackjackVIPBetaEvo: {
      href: "/casino/ezgevo-blackjack-vip-beta",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPBeta.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP Beta",
      name: "Blackjack VIP Beta",
      gameType: gameTypes.popular,
    },
    BlackjackVIPEEvo: {
      href: "/casino/ezgevo-blackjack-vip-e",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPE.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP E",
      name: "Blackjack VIP E",
      gameType: gameTypes.popular,
    },
    BlackjackVIPGammaEvo: {
      href: "/casino/ezgevo-blackjack-vip-gamma",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPGamma.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP Gamma",
      name: "Blackjack VIP Gamma",
      gameType: gameTypes.popular,
    },
    BlackjackVIPLEvo: {
      href: "/casino/ezgevo-blackjack-vip-l",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/BlackjackVIPL.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack VIP L",
      name: "Blackjack VIP L",
      gameType: gameTypes.popular,
    },
    ClassicSpeedBlackjack10Evo: {
      href: "/casino/ezgevo-classic-speed-blackjack-10",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/ClassicSpeedBlackjack10.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Classic Speed Blackjack 10",
      name: "Classic Speed Blackjack 10",
      gameType: gameTypes.popular,
    },
    FirstPersonBlackjackEvo: {
      href: "/casino/ezgevo-first-person-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/FirstPersonBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "First Person Blackjack",
      name: "First Person Blackjack",
      gameType: gameTypes.new,
    },
    FirstPersonLightningBlackjackEvo: {
      href: "/casino/ezgevo-first-person-lightning-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/FirstPersonLightningBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "First Person Lightning Blackjack",
      name: "First Person Lightning Blackjack",
      gameType: gameTypes.popular,
    },
    InfiniteBlackjackEvo: {
      href: "/casino/ezgevo-infinite-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/InfiniteBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Infinite Blackjack",
      name: "Infinite Blackjack",
      gameType: gameTypes.popular,
    },
    LightningBlackjackEvo: {
      href: "/casino/ezgevo-lightning-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/LightningBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Lightning Blackjack",
      name: "Lightning Blackjack",
      gameType: gameTypes.popular,
    },
    PowerBlackjackEvo: {
      href: "/casino/ezgevo-power-blackjack",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/PowerBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Power Blackjack",
      name: "Power Blackjack",
      gameType: gameTypes.new,
    },
    SpeedBlackjackDEvo: {
      href: "/casino/ezgevo-speed-blackjack-d",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/SpeedBlackjackD.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed Blackjack D",
      name: "Speed Blackjack D",
      gameType: gameTypes.popular,
    },
    SpeedVIPBlackjackAEvo: {
      href: "/casino/ezgevo-speed-vip-blackjack-a",
      code: "",
      casino: "ezugi",
      category: "blackjack",
      provider: "evolution",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/evolution/SpeedVIPBlackjackA.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Speed VIP Blackjack A",
      name: "Speed VIP Blackjack A",
      gameType: gameTypes.new,
    },

    LasVegasBlackjackVivo: {
      href: "/casino/vivo-las-vegas-blackjack",
      code: "",
      casino: "vivo",
      category: "blackjack",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/vivo/LasVegasBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Las Vegas Blackjack",
      name: "Las Vegas Blackjack",
      gameType: gameTypes.popular,
    },
    LimitlessBlackjackVivo: {
      href: "/casino/vivo-limitless-blackjack",
      code: "",
      casino: "vivo",
      category: "blackjack",
      provider: "vivo",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/blackjack/vivo/LimitlessBlackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Limitless Blackjack",
      name: "Limitless Blackjack",
      gameType: gameTypes.new,
    },

    BlackjackKM: {
      href: "/casino/km-blackjack",
      code: "",
      casino: "",
      category: "blackjack",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/blackjack/blackjack.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Blackjack",
      name: "Blackjack",
      gameType: gameTypes.new,
    },
  },

  other: {
    CardPoker5: {
      href: "/casino/km-5-card-poker",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/5-card-poker.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Card Poker",
      name: "Card Poker",
      gameType: gameTypes.popular,
    },
    BaiBuu: {
      href: "/casino/km-bai-buu",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/bai-buu.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Bai Buu",
      name: "Bai Buu",
      gameType: gameTypes.new,
    },
    BaiCao: {
      href: "/casino/km-bai-cao",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/bai-cao.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Bai Cao",
      name: "Bai Cao",
      gameType: gameTypes.new,
    },
    Belangkai2: {
      href: "/casino/km-belangkai-2",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/belangkai-2.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Belangkai 2",
      name: "Belangkai 2",
      gameType: gameTypes.new,
    },
    BolaGolek: {
      href: "/casino/km-bola-golek",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/bola-golek.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Bola Golek",
      name: "Bola Golek",
      gameType: gameTypes.popular,
    },
    BolaTangkas: {
      href: "/casino/km-bola-tangkas",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/bola-tangkas.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Bola Tangkas",
      name: "Bola Tangkas",
      gameType: gameTypes.popular,
    },
    BonusDice: {
      href: "/casino/km-bonus-dice",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/bonus-dice.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Bonus Dice",
      name: "Bonus Dice",
      gameType: gameTypes.new,
    },
    CashRocket: {
      href: "/casino/km-cash-rocket",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/cash-rocket.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Cash Rocket",
      name: "Cash Rocket",
      gameType: gameTypes.popular,
    },
    CleopatrasTreasure: {
      href: "/casino/km-cleopatras-treasure",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/cleopatras-treasure.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Cleopatras Treasure",
      name: "Cleopatras Treasure",
      gameType: gameTypes.new,
    },
    CockfightingArena: {
      href: "/casino/km-cockfighting-arena",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/cockfighting-arena.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Cockfighting Arena",
      name: "Cockfighting Arena",
      gameType: gameTypes.new,
    },
    CoinPusher: {
      href: "/casino/km-coin-pusher",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/coin-pusher.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Coin Pusher",
      name: "Coin Pusher",
      gameType: gameTypes.popular,
    },
    ColorGame: {
      href: "/casino/km-color-game",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/color-game.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Color Game",
      name: "Color Game",
      gameType: gameTypes.new,
    },
    DotaHiLo: {
      href: "/casino/km-dota-hi-lo",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/dota-hi-lo.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Dota Hi Lo",
      name: "Dota Hi Lo",
      gameType: gameTypes.popular,
    },
    EliteAviatorClub: {
      href: "/casino/km-elite-aviator-club",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/elite-aviator-club.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Elite Aviator Club",
      name: "Elite Aviator Club",
      gameType: gameTypes.popular,
    },
    FanTvanClassic: {
      href: "/casino/km-fan-tvan-classic",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/fan-tvan-classic.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Fan Tan Classic",
      name: "Fan Tan Classic",
      gameType: gameTypes.new,
    },
    FishPrawnCrab2: {
      href: "/casino/km-fish-prawn-crab-2",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/fish-prawn-crab-2.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Fish Prawn Crab 2",
      name: "Fish Prawn Crab 2",
      gameType: gameTypes.popular,
    },
    GemsOfValhalla: {
      href: "/casino/km-gems-of-valhalla",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/gems-of-valhalla.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gems Of Valhalla",
      name: "Gems Of Valhalla",
      gameType: gameTypes.new,
    },
    GoldMines: {
      href: "/casino/km-gold-mines",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/gold-mines.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Gold Mines",
      name: "Gold Mines",
      gameType: gameTypes.popular,
    },
    Heist: {
      href: "/casino/km-heist",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/heist.webp",
      plaBtn: "./images/play-btn.png",
      alt: "heist",
      name: "heist",
      gameType: gameTypes.popular,
    },
    InterstellarRun: {
      href: "/casino/km-interstellar-run",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/interstellar-run.webp",
      plaBtn: "./images/play-btn.png",
      alt: "InterstellarRun",
      name: "InterstellarRun",
      gameType: gameTypes.new,
    },
    JackpotJump: {
      href: "/casino/km-jackpot-jump",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/jackpot-jump.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Jackpot Jump",
      name: "Jackpot Jump",
      gameType: gameTypes.popular,
    },
    KMPokDeng: {
      href: "/casino/km-km-pok-deng",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/km-pok-deng.webp",
      plaBtn: "./images/play-btn.png",
      alt: "KM Pok Deng",
      name: "KM Pok Deng",
      gameType: gameTypes.new,
    },
    KMPowerBall: {
      href: "/casino/km-km-power-ball",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/km-power-ball.webp",
      plaBtn: "./images/play-btn.png",
      alt: "KM Power Ball",
      name: "KM Power Ball",
      gameType: gameTypes.popular,
    },
    KMVirtualHorseRacing: {
      href: "/casino/km-km-virtual-horse-racing",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/km-virtual-horse-racing.webp",
      plaBtn: "./images/play-btn.png",
      alt: "KM Virtual Horse Racing",
      name: "KM Virtual Horse Racing",
      gameType: gameTypes.new,
    },
    Ludo: {
      href: "/casino/km-ludo",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/ludo.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Ludo",
      name: "Ludo",
      gameType: gameTypes.popular,
    },
    MarbleRacing: {
      href: "/casino/km-marble-racing",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/marble-racing.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Marble Racing",
      name: "Marble Racing",
      gameType: gameTypes.popular,
    },
    MaxKeno: {
      href: "/casino/km-max-keno",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/max-keno.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Max Keno",
      name: "Max Keno",
      gameType: gameTypes.new,
    },
    Minesweeper: {
      href: "/casino/km-minesweeper",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/minesweeper.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Minesweeper",
      name: "Minesweeper",
      gameType: gameTypes.new,
    },
    OlympusGlory: {
      href: "/casino/km-olympus-glory",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/olympus-glory.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Olympus Glory",
      name: "Olympus Glory",
      gameType: gameTypes.new,
    },
    PaiKang: {
      href: "/casino/km-pai-kang",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/pai-kang.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Pai Kang",
      name: "Pai Kang",
      gameType: gameTypes.new,
    },
    PenguinPanic: {
      href: "/casino/km-penguin-panic",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/penguin-panic.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Penguin Panic",
      name: "Penguin Panic",
      gameType: gameTypes.new,
    },
    Plinko: {
      href: "/casino/km-plinko",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/plinko.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Plinko",
      name: "Plinko",
      gameType: gameTypes.popular,
    },
    Pusoy: {
      href: "/casino/km-pusoy",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/pusoy.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Pusoy",
      name: "Pusoy",
      gameType: gameTypes.new,
    },
    RoosterBlitz: {
      href: "/casino/km-rooster-blitz",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/rooster-blitz.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Rooster Blitz",
      name: "Rooster Blitz",
      gameType: gameTypes.new,
    },
    SugarBlast: {
      href: "/casino/km-sugar-blast",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/sugar-blast.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Sugar Blast",
      name: "Sugar Blast",
      gameType: gameTypes.popular,
    },
    SugarBlastFrenzy: {
      href: "/casino/km-sugar-blast-frenzy",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/sugar-blast-frenzy.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Sugar Blast Frenzy",
      name: "Sugar Blast Frenzy",
      gameType: gameTypes.popular,
    },
    TaiXiu: {
      href: "/casino/km-tai-xiu",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/tai-xiu.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Tai Xiu",
      name: "Tai Xiu",
      gameType: gameTypes.new,
    },
    TeenPatti: {
      href: "/casino/km-teen-patti",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/teen-patti.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Teen Patti",
      name: "Teen Patti",
      gameType: gameTypes.popular,
    },
    ThaiFishPrawnCrab: {
      href: "/casino/km-thai-fish-prawn-crab",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/thai-fish-prawn-crab.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Thai Fish Prawn Crab",
      name: "Thai Fish Prawn Crab",
      gameType: gameTypes.new,
    },
    ThaiHiLo2: {
      href: "/casino/km-thai-hi-lo-2",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/thai-hi-lo-2.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Thai Hi Lo 2",
      name: "Thai Hi Lo 2",
      gameType: gameTypes.popular,
    },
    Tongits: {
      href: "/casino/km-tongits",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/tongits.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Tongits",
      name: "Tongits",
      gameType: gameTypes.new,
    },
    TripleChance: {
      href: "/casino/km-triple-chance",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/triple-chance.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Triple Chance",
      name: "Triple Chance",
      gameType: gameTypes.new,
    },
    VideoPoker: {
      href: "/casino/km-video-poker",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/video-poker.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Video Poker",
      name: "Video Poker",
      gameType: gameTypes.popular,
    },
    VietFishPrawnCrab: {
      href: "/casino/km-viet-fish-prawn-crab",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/viet-fish-prawn-crab.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Viet Fish Prawn Crab",
      name: "Viet Fish Prawn Crab",
      gameType: gameTypes.new,
    },
    VirtualAnimalRace: {
      href: "/casino/km-virtual-animal-race",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/virtual-animal-race.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Virtual Animal Race",
      name: "Virtual Animal Race",
      gameType: gameTypes.popular,
    },
    VirtualGreyhoundRacing: {
      href: "/casino/km-virtual-greyhound-racing",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/virtual-greyhound-racing.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Virtual Greyhound Racing",
      name: "Virtual Greyhound Racing",
      gameType: gameTypes.popular,
    },
    VirtualTreadmillRacing: {
      href: "/casino/km-virtual-treadmill-racing",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/virtual-treadmill-racing.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Virtual Treadmill Racing",
      name: "Virtual Treadmill Racing",
      gameType: gameTypes.new,
    },
    XocLightning: {
      href: "/casino/km-xoc-lightning",
      code: "",
      casino: "",
      category: "other",
      provider: "kingmaker",
      homeUrl: pageUrlGenerator("/kingmaker"),
      imgUrl: "./images/kingmaker/others/xoc-lightning.webp",
      plaBtn: "./images/play-btn.png",
      alt: "Xoc Lightning",
      name: "Xoc Lightning",
      gameType: gameTypes.popular,
    },

    RedBlueDuelAes: {
      href: "/casino/awc-red-blue-duel",
      code: "",
      casino: "AE Sexy",
      category: "other",
      provider: "worldcasino",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/aesexy/RedBlueDuel.webp",
      plaBtn: "./images/play-btn.png",
      alt: "./images/aesexy/RedBlueDuel.webp",
      name: "Red Blue Duel",
      gameType: gameTypes.new,
    },
  },

  crash: {
    jetX: {
      href: "/casino/aggapsmartsoftgaming-jetx",
      code: "JetX",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/JetX.jpg",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "JetX",
      gameType: gameTypes.new,
    },
    aviatorCr: {
      href: "/casino/spribe/aviator",
      code: "aviator",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/aviator/aviator.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Aviator",
      gameType: gameTypes.new,
    },
    Keno: {
      href: "/casino/spribe/keno",
      code: "keno",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/keno.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Keno",
      gameType: gameTypes.new,
    },
    MiniRoulette: {
      href: "/casino/spribe/miniroulette",
      code: "mini-roulette",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/mini-roulette.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "Mini Roulette",
      gameType: gameTypes.popular,
    },
    hilo: {
      href: "/casino/spribe/hilo",
      code: "hi-lo",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/hilo.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "hilo",
      gameType: gameTypes.new,
    },
    dice: {
      href: "/casino/spribe/dice",
      code: "dice",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/dice.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "dice",
      gameType: gameTypes.popular,
    },
    mines: {
      href: "/casino/spribe/mines",
      code: "mines",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/mines.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "mines",
      gameType: gameTypes.new,
    },
    plinko: {
      href: "/casino/spribe/plinko",
      code: "plinko",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/plinko.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "plinko",
      gameType: gameTypes.popular,
    },
    goal: {
      href: "/casino/spribe/goal",
      code: "goal",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/goal.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "goal",
      gameType: gameTypes.popular,
    },
    hotline: {
      href: "/casino/spribe/hotline",
      code: "hotline",
      casino: "spribe",
      category: "crash",
      provider: "spribe",
      homeUrl: "http://localhost:3000/Casino",
      imgUrl: "./images/spribe/crash/hotline.webp",
      plaBtn: "./images/play-btn.png",
      alt: "",
      name: "hotline",
      gameType: gameTypes.new,
    },
  },



  vivo: {
    TeenPattiVivo: {
      name: "Teen Patti",
      redirectUrl: "/casino/vivo-teen-patti",
      code: "mines",
      casino: "spribe",
      provider: "vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/TeenPattiVivo1.webp", alt: "",
    },
    ndarbaharVivo: {
      name: "Andar Bahar",
      redirectUrl: "/casino/vivo-andar-bahar",
      code: "goal",
      casino: "spribe",
      provider: "vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/AndarBaharVivo1.webp", alt: "",
    },
    lasvegasjackpotroulette: {
      name: "Las Vegas Jackpot Roulette",
      redirectUrl: "/casino/vivo-las-vegas-jackpot-roulette",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/lasvegasjackpotrou1.jpg", alt: "",
    },
    lasvegasroulette: {
      name: "Las Vegas Roulette",
      redirectUrl: "/casino/vivo-las-vegas-roulette",
      code: "dice",
      casino: "spribe",
      provider: "dice",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/vivo-las-vegas-roulette1.webp", alt: "",
    },
    PortomasoRoulette: {
      name: "Portomaso Roulette",
      redirectUrl: "/casino/vivo-portomaso-roulette",
      code: "aviator",
      casino: "spribe",
      provider: "vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/vivo-portomaso-roulette1.webp", alt: "" ,
    },
    ImperialDragonTiger: {
      name: "Imperial Dragon Tiger",
      redirectUrl: "/casino/aggapvivogaming-imperial-dragon-tiger",
      code: "plinko",
      casino: "spribe",
      provider: "viov",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/imperialdragontiger1.jpg", alt: "" ,
    },
    BlazeRoulette: {
      name: "Blaze Roulette",
      redirectUrl: "/casino/vivo-oracle-blaze-roulette",
      code: "mini-roulette",
      casino: "spribe",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/vivo-oracle-blaze-roulette1.webp", alt: "" ,
    },
    OracleTwisterRoulette: {
      name: "Oracle Twister Roulette",
      redirectUrl: "/casino/aggapvivogaming-oracle-twister-roulette",
      code: "hi-lo",
      casino: "spribe",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/OracleTwisterRoulette1.jpg", alt: "" ,
    },
    AmericanAutoRoulette: {
      name: "American Auto Roulette",
      redirectUrl: "/casino/aggapvivogaming-american-auto-roulette",
      code: "hi-lo",
      casino: "spribe",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/AmericanAutoRoulette1.jpg", alt: "" ,
    },
    Oracle360Roulette: {
      name: "Oracle 360 Roulette",
      redirectUrl: "/casino/vivo-oracle-360-roulette",
      code: "hi-lo",
      casino: "spribe",
      provider: "Vivo",
      homeUrl: "",
      providerName: "Vivo",
      imgUrl: "./images/vivo/Oracle360Roulette1.jpg", alt: "" ,
    },
  }
  
};
